import { __assign, __extends } from "tslib";
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { MdSwapHoriz } from 'react-icons/md';
import { QuantityInput } from './QuantityInput';
import { clone } from 'lodash';
import { computeQuantityGridTotals } from './utils/computeQuantityGridTotals';
import { roundAmount } from './utils/priceHelper';
var baseUrl = process.env.NODE_ENV === 'production' ? '/' : 'http://aws.molohub.com/';
function getAvailableQuantityForItem(item, isReorder) {
    var _a, _b;
    if (isReorder) {
        return item.available;
    }
    return item.available + ((_b = (_a = item.availablenos) !== null && _a !== void 0 ? _a : item.dispnos) !== null && _b !== void 0 ? _b : 0);
}
var QuantityGrid = /** @class */ (function (_super) {
    __extends(QuantityGrid, _super);
    function QuantityGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableRef = React.createRef();
        _this.currentRowIndex = 1;
        _this.cellLength = 0;
        _this.tableLength = 0;
        _this.state = {
            currentCellIndex: 0,
            realCellIndex: 2,
            inputsRendered: false,
            bulkQuantity: 1,
            rowsPendingBulkUndo: {},
            gridPendingBulkUndo: false,
        };
        _this.initialCheck = function () {
            if (_this.tableRef.current !== null) {
                _this.tableLength = _this.tableRef.current.rows.length;
                _this.cellLength = _this.tableRef.current.rows[0].cells.length;
                _this.setState({ realCellIndex: _this.getFirstSizeCellIndex() }, function () {
                    _this.initialFocus();
                });
            }
        };
        _this.handleKeyUp = function (_e) { };
        _this.handleKeyDown = function (e) {
            var isRight = e.key === 'ArrowRight' || e.key === 'Tab';
            var isLeft = e.key === 'ArrowLeft';
            var isUp = e.key === 'ArrowUp';
            var isDown = e.key === 'ArrowDown';
            if (isRight || isLeft || isUp || isDown) {
                e.preventDefault();
                _this.handleNextInput(isRight, isLeft, isDown, isUp);
            }
        };
        /** Scroll the selected/active variant row into the nearest scroll container (overlay grid frame). */
        _this.scrollActiveRowIntoView = function () {
            if (!_this.tableRef.current) {
                return false;
            }
            var scrollBlock = _this.props.layout === 'overlay' ? 'center' : 'nearest';
            var targetRow = null;
            var active = document.activeElement;
            if (active instanceof HTMLInputElement) {
                var tr = active.closest('tr');
                if (tr instanceof HTMLTableRowElement && _this.tableRef.current.contains(tr)) {
                    targetRow = tr;
                }
            }
            if (!targetRow) {
                var rows = _this.tableRef.current.rows;
                for (var i = 0; i < rows.length; i++) {
                    if (rows[i].classList.contains('active-row')) {
                        targetRow = rows[i];
                        break;
                    }
                }
            }
            if (!targetRow) {
                return false;
            }
            var focusInput = targetRow.querySelector('input');
            var scrollTarget = (focusInput && focusInput.closest('td')) || targetRow;
            scrollTarget.scrollIntoView({
                block: scrollBlock,
                inline: 'nearest',
                behavior: 'auto',
            });
            if (focusInput) {
                focusInput.focus();
                if (typeof focusInput.select === 'function') {
                    focusInput.select();
                }
            }
            return true;
        };
        _this.handleOnFocus = function (e) {
            e.preventDefault();
            var currentInput = e.target;
            if (_this.tableRef.current) {
                currentInput.select();
                if (currentInput) {
                    var closest = currentInput.closest('td');
                    if (closest) {
                        closest.classList.add('cell-is-active');
                        var realCellIndex = closest.cellIndex;
                        _this.setState({ realCellIndex: realCellIndex });
                    }
                    var allCells = _this.tableRef.current.getElementsByTagName('td');
                    for (var i in allCells) {
                        if (allCells[i] && allCells[i] !== closest) {
                            if (allCells[i].classList) {
                                allCells[i].classList.remove('cell-is-active');
                            }
                        }
                    }
                    var row = currentInput.closest('tr');
                    if (row) {
                        var rowIndex = row.rowIndex;
                        _this.notifyActiveVariantForRow(rowIndex);
                        _this.notifyActiveCell(rowIndex, closest.cellIndex);
                    }
                }
            }
        };
        _this.handleOnClick = function (e) {
            var field = e.target;
            _this.currentRowIndex = field.closest('tr').rowIndex;
            _this.notifyActiveVariantForRow(_this.currentRowIndex);
            if (_this.tableRef.current) {
                var inputs = _this.tableRef.current.rows[_this.currentRowIndex].getElementsByTagName('input');
                var _loop_1 = function (key) {
                    var input = inputs[key];
                    if (input === field) {
                        var closest_1 = input.closest('td');
                        if (closest_1) {
                            _this.setState({ realCellIndex: closest_1.cellIndex }, function () {
                                input.focus();
                                _this.notifyActiveCell(_this.currentRowIndex, closest_1.cellIndex);
                            });
                        }
                    }
                };
                for (var key in inputs) {
                    _loop_1(key);
                }
            }
        };
        _this.getAvailableQuantity = function (item) {
            return getAvailableQuantityForItem(item, _this.isReorderOrder());
        };
        _this.getCurrentQuantity = function (itemId) {
            var pendingChanges = _this.props.changes;
            if (pendingChanges && pendingChanges[itemId] !== undefined) {
                return +pendingChanges[itemId] || '';
            }
            if (_this.props.basket && _this.props.basket.basketLines) {
                return +_this.props.basket.basketLines[itemId] || '';
            }
            return '';
        };
        _this.getGridTotals = function () {
            var _a = _this.props, moloItems = _a.moloItems, changes = _a.changes, basket = _a.basket, orderHeader = _a.orderHeader, lineDiscount = _a.lineDiscount, showRowTotals = _a.showRowTotals;
            if (!showRowTotals) {
                return null;
            }
            return computeQuantityGridTotals({
                moloItems: moloItems,
                changes: changes,
                basketLines: basket && basket.basketLines,
                hasOrder: !!orderHeader,
                lineDiscount: lineDiscount || 0,
            });
        };
        _this.rowKeysTouchingItems = function (items) {
            var ids = new Set(items.map(function (i) { return i.itemId; }));
            return Object.keys(_this.props.moloItems).filter(function (rowKey) {
                return (_this.props.moloItems[rowKey] || []).some(function (it) { return ids.has(it.itemId); });
            });
        };
        _this.applyBulkAddToItems = function (items, onlyAvailable, quantityOverride, opts) {
            if (!items || !items.length) {
                return;
            }
            var rawBulk = quantityOverride !== undefined && quantityOverride !== null
                ? quantityOverride
                : _this.state.bulkQuantity;
            var isClear = rawBulk === 0;
            var quantity = isClear ? 0 : Math.max(1, rawBulk || 1);
            var changes = {};
            items.forEach(function (item) {
                var available = _this.getAvailableQuantity(item);
                if (item.blocked === 1) {
                    return;
                }
                if (isClear) {
                    changes[item.itemId] = 0;
                    return;
                }
                if (onlyAvailable && available < 1) {
                    return;
                }
                var capped = Math.min(quantity, Math.max(0, available));
                if (capped < 1) {
                    return;
                }
                var currentQty = _this.getCurrentQuantity(item.itemId);
                var currentNum = currentQty === '' ? 0 : +currentQty;
                if (currentNum === capped) {
                    return;
                }
                changes[item.itemId] = capped;
            });
            if (!Object.keys(changes).length) {
                return;
            }
            _this.props.updateChanges(changes);
            var fromHeader = !!(opts && opts.fromHeader);
            var singleRowKey = opts && opts.singleRowKey;
            if (isClear) {
                _this.setState(function (prev) {
                    var next = __assign({}, prev.rowsPendingBulkUndo);
                    if (fromHeader) {
                        return { rowsPendingBulkUndo: {}, gridPendingBulkUndo: false };
                    }
                    if (singleRowKey) {
                        delete next[singleRowKey];
                        return {
                            rowsPendingBulkUndo: next,
                            gridPendingBulkUndo: prev.gridPendingBulkUndo,
                        };
                    }
                    _this.rowKeysTouchingItems(items).forEach(function (k) {
                        delete next[k];
                    });
                    return {
                        rowsPendingBulkUndo: next,
                        gridPendingBulkUndo: prev.gridPendingBulkUndo,
                    };
                });
                return;
            }
            _this.setState(function (prev) {
                var next = __assign({}, prev.rowsPendingBulkUndo);
                if (fromHeader) {
                    _this.rowKeysTouchingItems(items).forEach(function (k) {
                        var rowItems = _this.props.moloItems[k] || [];
                        var touched = rowItems.some(function (it) { return changes[it.itemId] !== undefined; });
                        if (touched) {
                            next[k] = true;
                        }
                    });
                }
                else if (singleRowKey) {
                    next[singleRowKey] = true;
                }
                return {
                    rowsPendingBulkUndo: next,
                    gridPendingBulkUndo: fromHeader ? true : prev.gridPendingBulkUndo,
                };
            });
        };
        _this.handleRowBulkClick = function (rowKey, rowItems) {
            var _a = _this.state, bulkQuantity = _a.bulkQuantity, rowsPendingBulkUndo = _a.rowsPendingBulkUndo;
            var pending = !!rowsPendingBulkUndo[rowKey];
            if (pending && bulkQuantity > 0) {
                _this.applyBulkAddToItems(rowItems, true, 0, { singleRowKey: rowKey });
            }
            else {
                _this.applyBulkAddToItems(rowItems, true, null, { singleRowKey: rowKey });
            }
            _this.notifyActiveVariantForRowKey(rowKey);
            _this.notifyFirstActiveCellForRow(rowKey, rowItems);
        };
        _this.renderRowBulkLabel = function (rowKey) {
            var _a = _this.state, bulkQuantity = _a.bulkQuantity, rowsPendingBulkUndo = _a.rowsPendingBulkUndo;
            if (bulkQuantity === 0 || rowsPendingBulkUndo[rowKey]) {
                return 'Clear';
            }
            return (React.createElement("span", { className: "quantity-grid__row-bulk-btn__content" },
                React.createElement("span", { className: "quantity-grid__row-bulk-btn__qty" }, bulkQuantity),
                React.createElement(MdSwapHoriz, { "aria-hidden": "true", className: "quantity-grid__row-bulk-btn__icon" })));
        };
        _this.renderRowBulkCell = function (itemKey, rowItems) { return (React.createElement("td", { className: "quantity-grid__cell quantity-grid__cell--row-action" },
            React.createElement("button", { type: "button", className: "quantity-grid__row-bulk-btn", "aria-label": _this.state.bulkQuantity === 0
                    ? 'Clear all sizes for this color'
                    : _this.state.rowsPendingBulkUndo[itemKey]
                        ? 'Clear quick-add quantities for this color row'
                        : "Set each in-stock size in this row to ".concat(_this.state.bulkQuantity), onClick: function () { return _this.handleRowBulkClick(itemKey, rowItems); } }, _this.renderRowBulkLabel(itemKey)))); };
        _this.renderBulkToolbar = function () {
            var _a = _this.props, moloItems = _a.moloItems, sectionTitle = _a.sectionTitle, layout = _a.layout;
            var isOverlay = layout === 'overlay';
            var bulkQuantityOptions = [0, 1, 2, 3, 4, 5, 10, 20];
            return (React.createElement("div", { className: 'quantity-grid__section-header' +
                    (isOverlay ? ' quantity-grid__section-header--overlay' : '') },
                sectionTitle && (React.createElement("div", { className: "quantity-grid__section-header__anchor" },
                    React.createElement("h2", { className: "quantity-grid__section-header__title" }, sectionTitle))),
                React.createElement("div", { className: "quantity-grid__section-header__tools" },
                    React.createElement("span", { className: "quantity-grid__section-header__qty-group" },
                        React.createElement("span", { className: "quantity-grid__section-header__label" }, "Quick add"),
                        React.createElement("select", { id: "bulk-qty-select", "aria-label": "Quick add quantity", className: "quantity-grid__section-header__select", value: _this.state.bulkQuantity, onChange: function (event) {
                                var next = +event.target.value;
                                _this.setState({
                                    bulkQuantity: Number.isNaN(next) ? 1 : next,
                                    rowsPendingBulkUndo: {},
                                    gridPendingBulkUndo: false,
                                });
                            } }, bulkQuantityOptions.map(function (qty) { return (React.createElement("option", { key: qty, value: qty }, isOverlay && qty > 0 ? "".concat(qty, " piece").concat(qty === 1 ? '' : 's') : qty)); }))),
                    React.createElement("button", { type: "button", className: "button quantity-grid__section-header__btn", "aria-label": _this.state.bulkQuantity === 0
                            ? 'Clear quantities for all sizes in the grid'
                            : 'Set all in-stock cells to the selected quick-add quantity', onClick: function () {
                            var allItems = Object.keys(moloItems).reduce(function (acc, key) { return acc.concat(moloItems[key]); }, []);
                            _this.applyBulkAddToItems(allItems, true, _this.state.bulkQuantity === 0 ? 0 : null, { fromHeader: true });
                        } }, _this.state.bulkQuantity === 0 ? 'Clear all' : 'Set all'))));
        };
        _this.renderStockLegend = function () { return (React.createElement("div", { className: "quantity-grid__stock-legend" },
            React.createElement("div", { className: "quantity-grid__stock-legend-item" },
                React.createElement("div", { className: "infiniteAvailability" }),
                React.createElement("span", null, "Full stock")),
            React.createElement("div", { className: "quantity-grid__stock-legend-item" },
                React.createElement("div", { className: "mediumAvailability" }),
                React.createElement("span", null, "Limited stock")),
            React.createElement("div", { className: "quantity-grid__stock-legend-item" },
                React.createElement("div", { className: "lowAvailability" }),
                React.createElement("span", null, "Low stock")))); };
        _this.renderFooterBar = function () {
            var _a = _this.props, onConfirm = _a.onConfirm, confirmLabel = _a.confirmLabel, showFooterConfirm = _a.showFooterConfirm;
            if (showFooterConfirm === false || !onConfirm) {
                return null;
            }
            return (React.createElement("div", { className: "quantity-grid__footer" },
                React.createElement("button", { type: "button", className: "quantity-grid__footer__confirm", onClick: onConfirm }, confirmLabel || 'Confirm and Add to Order')));
        };
        _this.getHeaderCellClass = function (cellIndex, extra) {
            var isActive = cellIndex === _this.state.realCellIndex;
            return ('quantity-grid__cell' +
                (extra ? ' ' + extra : '') +
                (isActive ? ' cell-is-active' : ''));
        };
        return _this;
    }
    QuantityGrid.prototype.isReorderOrder = function () {
        var _a = this.props, orderHeader = _a.orderHeader, orderState = _a.orderState;
        if (orderHeader && orderHeader.orderType) {
            return orderHeader.orderType.toUpperCase() === 'REORDER';
        }
        var order = orderState && orderState.order;
        if (!order) {
            return false;
        }
        var orderType = (order.orderheader && order.orderheader.orderType) ||
            (order.orderHeader && order.orderHeader.orderType);
        return orderType ? String(orderType).toUpperCase() === 'REORDER' : false;
    };
    QuantityGrid.prototype.getFirstSizeCellIndex = function () {
        return this.props.layout === 'overlay' ? 1 : 2;
    };
    QuantityGrid.prototype.getLastSizeCellIndex = function () {
        return this.getFirstSizeCellIndex() + this.props.sizes.length - 1;
    };
    QuantityGrid.prototype.getRowImageUrlForItem = function (seasonCode, masterId, colorCode) {
        if (this.props.getRowImageUrl) {
            return this.props.getRowImageUrl(seasonCode, masterId, colorCode);
        }
        return (baseUrl +
            'productimage/' +
            seasonCode +
            '/' +
            masterId +
            '/' +
            colorCode +
            '/small');
    };
    QuantityGrid.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        var moloItemsRefChanged = prevProps.moloItems !== this.props.moloItems;
        var prevRowKeys = Object.keys(prevProps.moloItems).sort();
        var nextRowKeys = Object.keys(this.props.moloItems).sort();
        var rowStructureChanged = prevRowKeys.length !== nextRowKeys.length ||
            prevRowKeys.join('|') !== nextRowKeys.join('|');
        var colorChanged = this.props.selectedProduct.colorCode !== prevProps.selectedProduct.colorCode;
        var resetForColorChange = colorChanged && this.props.layout !== 'overlay';
        if (moloItemsRefChanged || rowStructureChanged || resetForColorChange) {
            if (rowStructureChanged || resetForColorChange) {
                this.setState({
                    inputsRendered: false,
                    rowsPendingBulkUndo: {},
                    gridPendingBulkUndo: false,
                });
            }
            else {
                this.setState({ inputsRendered: false });
            }
        }
        if (this.tableRef.current !== null) {
            var rows = document.querySelector('#quantity-grid-table');
            if (rows) {
                if (!this.state.inputsRendered) {
                    this.setState({ inputsRendered: true }, function () {
                        _this.initialCheck();
                    });
                }
            }
        }
        var portalTarget = this.props.toolbarPortalTarget;
        if (this.props.hideSectionHeader &&
            portalTarget &&
            portalTarget.current &&
            (!prevProps.toolbarPortalTarget || !prevProps.toolbarPortalTarget.current)) {
            this.forceUpdate();
        }
    };
    QuantityGrid.prototype.handleNextInput = function (isRight, isLeft, isDown, isUp) {
        var _this = this;
        if (isRight === void 0) { isRight = false; }
        var currentCellIndex = clone(this.state.realCellIndex);
        var firstSize = this.getFirstSizeCellIndex();
        var lastSize = this.getLastSizeCellIndex();
        if (this.tableRef.current !== null) {
            if (currentCellIndex >= lastSize && isRight && !isUp && !isDown) {
                currentCellIndex = firstSize;
                this.currentRowIndex++;
                if (this.currentRowIndex === this.tableLength) {
                    this.currentRowIndex = 1;
                }
            }
            else if (isRight && !isUp && !isDown) {
                currentCellIndex++;
            }
            else if (isLeft && !isUp && !isDown) {
                currentCellIndex--;
                if (currentCellIndex < firstSize) {
                    currentCellIndex = lastSize;
                    if (this.currentRowIndex === 1) {
                        this.currentRowIndex = this.tableLength - 1;
                    }
                    else {
                        this.currentRowIndex--;
                    }
                }
            }
            else if (isUp) {
                this.currentRowIndex--;
                if (this.currentRowIndex <= 0) {
                    this.currentRowIndex = this.tableLength - 1;
                }
            }
            else if (isDown) {
                this.currentRowIndex++;
                if (this.currentRowIndex === this.tableLength) {
                    this.currentRowIndex = 1;
                }
            }
            var tds = this.tableRef.current.rows[this.currentRowIndex].getElementsByTagName('td');
            var input_1 = tds[currentCellIndex].getElementsByTagName('input');
            var realCellIndex_1 = 0;
            if (input_1[0]) {
                var closest = input_1[0].closest('td');
                if (closest) {
                    realCellIndex_1 = closest.cellIndex;
                }
            }
            else {
                realCellIndex_1 = currentCellIndex;
            }
            this.setState({ currentCellIndex: currentCellIndex, realCellIndex: realCellIndex_1 }, function () {
                _this.notifyActiveVariantForRow(_this.currentRowIndex);
                _this.notifyActiveCell(_this.currentRowIndex, realCellIndex_1);
                if (input_1[0]) {
                    input_1[0].focus();
                }
                else {
                    _this.handleNextInput(isRight, isLeft, isDown, isUp);
                }
            });
        }
    };
    QuantityGrid.prototype.initialFocus = function () {
        var _this = this;
        if (this.tableRef.current) {
            var rows = this.tableRef.current.rows;
            if (rows) {
                var _loop_2 = function (i) {
                    var row = rows[i].classList.contains('active-row');
                    if (row) {
                        var inputs = rows[i].getElementsByTagName('input');
                        this_1.currentRowIndex = i;
                        if (inputs.length) {
                            var el = inputs[0];
                            el.focus();
                            var closest_2 = el.closest('td');
                            if (closest_2) {
                                var realCellIndex_2 = closest_2.cellIndex;
                                this_1.setState({ realCellIndex: realCellIndex_2 }, function () {
                                    if (_this.props.layout !== 'overlay') {
                                        closest_2.scrollIntoView({
                                            block: 'start',
                                            inline: 'nearest',
                                            behavior: 'auto',
                                        });
                                    }
                                    _this.notifyActiveCell(i, realCellIndex_2);
                                });
                            }
                        }
                        else {
                            var cells = rows[i].getElementsByTagName('td');
                            var closest = cells[0];
                            if (this_1.props.layout !== 'overlay') {
                                closest.scrollIntoView({
                                    block: 'start',
                                    inline: 'nearest',
                                    behavior: 'auto',
                                });
                            }
                        }
                        return "break";
                    }
                };
                var this_1 = this;
                for (var i = 0; i < rows.length; i++) {
                    var state_1 = _loop_2(i);
                    if (state_1 === "break")
                        break;
                }
            }
        }
    };
    /** Focus first size input for a variant row; no-op if that row already has input focus. */
    QuantityGrid.prototype.focusVariantRow = function (variantKey) {
        var _this = this;
        if (!this.tableRef.current) {
            return false;
        }
        var keys = Object.keys(this.props.moloItems);
        var dataRowIndex = keys.indexOf(variantKey);
        if (dataRowIndex < 0) {
            return false;
        }
        var rowIndex = dataRowIndex + 1;
        var row = this.tableRef.current.rows[rowIndex];
        if (!row) {
            return false;
        }
        var active = document.activeElement;
        if (active instanceof HTMLInputElement &&
            active.closest('tr') === row) {
            return true;
        }
        var inputs = row.getElementsByTagName('input');
        if (!inputs.length) {
            return false;
        }
        var el = inputs[0];
        this.currentRowIndex = rowIndex;
        var closest = el.closest('td');
        if (closest) {
            this.setState({ realCellIndex: closest.cellIndex }, function () {
                el.focus();
                if (typeof el.select === 'function') {
                    el.select();
                }
                _this.notifyActiveVariantForRow(rowIndex);
                _this.notifyActiveCell(rowIndex, closest.cellIndex);
                closest.scrollIntoView({
                    block: _this.props.layout === 'overlay' ? 'center' : 'nearest',
                    inline: 'nearest',
                    behavior: 'auto',
                });
            });
        }
        else {
            el.focus();
            if (typeof el.select === 'function') {
                el.select();
            }
            this.notifyActiveVariantForRow(rowIndex);
        }
        return true;
    };
    QuantityGrid.prototype.getVariantKeyForTableRow = function (rowIndex) {
        var keys = Object.keys(this.props.moloItems);
        var dataRowIndex = rowIndex - 1;
        if (dataRowIndex < 0 || dataRowIndex >= keys.length) {
            return null;
        }
        return keys[dataRowIndex];
    };
    QuantityGrid.prototype.notifyActiveVariantForRow = function (rowIndex) {
        if (!this.props.onActiveVariantChange) {
            return;
        }
        var key = this.getVariantKeyForTableRow(rowIndex);
        if (key) {
            this.props.onActiveVariantChange(key);
        }
    };
    QuantityGrid.prototype.notifyActiveVariantForRowKey = function (rowKey) {
        if (!this.props.onActiveVariantChange) {
            return;
        }
        this.props.onActiveVariantChange(rowKey);
    };
    QuantityGrid.prototype.notifyFirstActiveCellForRow = function (rowKey, rowItems) {
        if (!this.props.onActiveCellChange || !rowItems.length) {
            return;
        }
        var itemIndex = 0;
        var item = rowItems[0];
        for (var i = 0; i < rowItems.length; i++) {
            if (this.getAvailableQuantity(rowItems[i]) > 0) {
                item = rowItems[i];
                itemIndex = i;
                break;
            }
        }
        this.props.onActiveCellChange({
            variantKey: rowKey,
            sizeIndex: itemIndex,
            whp: item.whp,
            msrp: item.msrp,
        });
    };
    QuantityGrid.prototype.notifyActiveCell = function (rowIndex, cellIndex) {
        if (!this.props.onActiveCellChange) {
            return;
        }
        var variantKey = this.getVariantKeyForTableRow(rowIndex);
        if (!variantKey) {
            return;
        }
        var rowItems = this.props.moloItems[variantKey];
        if (!rowItems || !rowItems.length) {
            return;
        }
        var firstSizeCellIndex = this.getFirstSizeCellIndex();
        var itemIndex = cellIndex - firstSizeCellIndex;
        var lastSizeCellIndex = firstSizeCellIndex + rowItems.length - 1;
        if (itemIndex < 0 || cellIndex > lastSizeCellIndex) {
            return;
        }
        var item = rowItems[itemIndex];
        if (!item) {
            return;
        }
        this.props.onActiveCellChange({
            variantKey: variantKey,
            sizeIndex: itemIndex,
            whp: item.whp,
            msrp: item.msrp,
        });
    };
    QuantityGrid.prototype.render = function () {
        var _this = this;
        var _a = this.props, sizes = _a.sizes, moloItems = _a.moloItems, selectedProduct = _a.selectedProduct, orderHeader = _a.orderHeader, layout = _a.layout, stockDisplay = _a.stockDisplay, showRowTotals = _a.showRowTotals, rowTotalMode = _a.rowTotalMode;
        var isOverlay = layout === 'overlay';
        var colorNameCellIndex = isOverlay ? 0 : 1;
        var firstSizeCellIndex = this.getFirstSizeCellIndex();
        var gridTotals = this.getGridTotals();
        var showRowQuantity = rowTotalMode === 'quantity';
        var indexCounter = 0;
        var toolbar = this.renderBulkToolbar();
        var toolbarPortal = this.props.hideSectionHeader &&
            this.props.toolbarPortalTarget &&
            this.props.toolbarPortalTarget.current
            ? ReactDOM.createPortal(toolbar, this.props.toolbarPortalTarget.current)
            : null;
        var table = (React.createElement("table", { className: 'quantity-grid' + (isOverlay ? ' quantity-grid--overlay' : ''), id: "quantity-grid-table", ref: this.tableRef },
            React.createElement("thead", null,
                React.createElement("tr", { className: "quantity-grid__header" },
                    !isOverlay && (React.createElement("th", { className: this.getHeaderCellClass(0), "aria-hidden": isOverlay ? true : undefined }, selectedProduct.description)),
                    React.createElement("th", { className: this.getHeaderCellClass(colorNameCellIndex, 'quantity-grid__cell--color-name') }, isOverlay ? 'Color Name' : 'Color name'),
                    sizes.map(function (size, index) {
                        var cellIndex = index + firstSizeCellIndex;
                        return (React.createElement("th", { key: size.code, className: _this.getHeaderCellClass(cellIndex) },
                            React.createElement("div", null, size.name)));
                    }),
                    showRowTotals && (React.createElement("th", { className: this.getHeaderCellClass(sizes.length + firstSizeCellIndex, 'quantity-grid__cell--row-total'), "aria-label": showRowQuantity
                            ? 'Total quantity for selected lines in row'
                            : 'Row total for selected quantities' }, showRowQuantity ? 'Qty' : 'Total')),
                    React.createElement("th", { className: this.getHeaderCellClass(sizes.length + firstSizeCellIndex + (showRowTotals ? 1 : 0), 'quantity-grid__cell--row-action'), "aria-label": "Set row to selected quick-add quantity" }, "Set"))),
            React.createElement("tbody", { className: "quantity-grid__body" }, Object.keys(moloItems).map(function (itemKey, key) {
                var rowItems = moloItems[itemKey];
                var myComponentClass = itemKey ===
                    _this.props.selectedProduct.masterId +
                        _this.props.selectedProduct.colorCode
                    ? 'active-row'
                    : '';
                return (React.createElement("tr", { className: "quantity-grid__row ".concat(myComponentClass), key: itemKey },
                    !isOverlay && (React.createElement("td", { className: "quantity-grid__cell quantity-grid__cell--image" },
                        React.createElement("img", { src: _this.getRowImageUrlForItem(rowItems[0].seasonCode, rowItems[0].masterId, rowItems[0].colorCode), alt: rowItems[0].colorName }))),
                    React.createElement("td", { className: "quantity-grid__cell quantity-grid__cell--color-name" }, rowItems[0].colorName),
                    rowItems.map(function (item) {
                        indexCounter++;
                        var currentQuantity = _this.getCurrentQuantity(item.itemId);
                        var available = _this.getAvailableQuantity(item);
                        return (_this.props.basket && (React.createElement(QuantityInput, { idx: indexCounter, key: item.itemId + item.sizeCode + item.sizeName, quantity: currentQuantity, available: available, itemId: item.itemId, updateChanges: _this.props.updateChanges, handleKeyDown: _this.handleKeyDown, handleOnFocus: _this.handleOnFocus, handleKeyUp: _this.handleKeyUp, blocked: item.blocked === 1, handeClick: _this.handleOnClick, soldOut: (!+currentQuantity || +currentQuantity < 1) &&
                                available < 1, orderHeader: orderHeader || null, layout: layout, stockDisplay: stockDisplay })));
                    }),
                    showRowTotals && (React.createElement("td", { className: 'quantity-grid__cell quantity-grid__cell--row-total' +
                            (gridTotals && (showRowQuantity
                                ? gridTotals.rowQuantities[itemKey] > 0
                                : gridTotals.rowTotals[itemKey] > 0)
                                ? ' quantity-grid__cell--row-total--visible'
                                : '') }, gridTotals && (showRowQuantity
                        ? gridTotals.rowQuantities[itemKey] > 0
                            ? gridTotals.rowQuantities[itemKey]
                            : '—'
                        : gridTotals.rowTotals[itemKey] > 0
                            ? roundAmount(gridTotals.rowTotals[itemKey])
                            : '—'))),
                    _this.renderRowBulkCell(itemKey, rowItems)));
            }))));
        return (React.createElement("div", { className: 'quantity-grid__wrapper' + (isOverlay ? ' quantity-grid__wrapper--overlay' : '') },
            toolbarPortal,
            !this.props.hideSectionHeader && toolbar,
            React.createElement("div", { className: "quantity-grid__scroll" }, table),
            isOverlay && this.props.showFooterBar && this.renderStockLegend(),
            isOverlay && this.props.showFooterBar && this.renderFooterBar()));
    };
    return QuantityGrid;
}(Component));
export { QuantityGrid };
//# sourceMappingURL=QuantityGrid.js.map